// extracted by mini-css-extract-plugin
export default {"filter_main_container":"Filters_filter_main_container__+LGdc","filter_head":"Filters_filter_head__Y5qh7","filter_ctg":"Filters_filter_ctg__kOdhC"};